//import React from "react"
import firebase from 'firebase';
import moment from 'moment';

export class UpdateService {
  updateOne = (resource, params) => {
    console.log('updateOne', resource, params);

    if (resource === 'users') {
      const { role, id, ...userWithoutRoleAndId } = params.data;

      return firebase
        .database()
        .ref(`users/${id}`)
        .update(userWithoutRoleAndId)
        .then(_ => {
          console.log('Updated with Success');

          if (role === 'noAdmin') {
            firebase
              .database()
              .ref(`admins/${id}`)
              .remove();
          } else {
            firebase
              .database()
              .ref(`admins/${id}`)
              .update({ role });
          }

          return { data: params.data };
        });
    }
    // UPDATE AN EVENT
    else if (resource === 'events') {
      const { id, isPlanned, ...dataWithoutId } = params.data;

      const eventWithoutIsPlanned = Object.assign(dataWithoutId, {
        isCanceled: !isPlanned
      });

      return firebase
        .database()
        .ref(`${resource}/${params.id}`)
        .update(eventWithoutIsPlanned)
        .then(_ => {
          console.log('Updated with Success');
          return { data: params.data };
        });

      // UPDATE A COMPANY
    } else if (resource === 'companies') {
      const { id, ...dataWithoutId } = params.data;

      dataWithoutId.name = dataWithoutId.name.toLowerCase();
      const updatedData = firebase
        .database()
        .ref(`${resource}/${params.id}`)
        .update(dataWithoutId)
        .then(_ => {
          console.log('Updated with Success');
          return { data: params.data };
        });
      return updatedData;

      // UPDATE A MISSION
    } else if (resource === 'missions') {
      //OLD VALUES IN THE FORM
      const {
        pic_thumbnail: previous_pic_thumbnail,
        pic_cover: previous_pic_cover
      } = params.previousData;

      // NEW VALUES IN THE FORM
      const {
        pic_thumbnail: thumbnail,
        pic_cover: cover,
        title,
        subtitle,
        description,
        location,
        startDate,
        endDate,
        state,
        creationTime
      } = params.data;

      console.log('thumbnail : ', thumbnail, 'cover : ', cover);
      console.log(
        'previous_pic_thumbnail : ',
        previous_pic_thumbnail,
        'previous_pic_cover : ',
        previous_pic_cover
      );

      const saveMediaAndGetUrl = async (media, type, oldMedia) => {
        if (!media) {
          return false;
        } else if (media.title === oldMedia.title) {
          return { url: oldMedia.src, title: oldMedia.title };
        }
        //ONLY IF NEW THUMBNAIL && || COVER IN FORM
        let { title: mediaName } = media;
        let mediaFile = media.rawFile;
        let mediaBlob = new Blob([mediaFile]);

        await firebase
          .storage()
          .ref(`missions/${creationTime}/${type}_pictures`)
          .child(oldMedia.title)
          .delete()
          .then(() => console.log('Bravo, fichier supprimé'))
          .catch(err =>
            console.log('Désolé, impossible de supprimer le fichier ', err)
          );

        return await firebase
          .storage()
          .ref(`missions/${creationTime}/${type}_pictures`)
          .child(mediaName)
          .put(mediaBlob)
          .then(() => {
            return firebase
              .storage()
              .ref(`missions/${creationTime}/${type}_pictures`)
              .child(mediaName)
              .getDownloadURL()
              .then(url => {
                console.log('url ', url);
                return { url, title: mediaName };
              });
          })
          .catch(error => {
            console.error(error);
            return { url: '', title: '' };
          });
      };

      const formatDate = date => {
        //const formated = moment(date);
        const formated = moment(date)
          .locale('en')
          .format('lll');
        return formated;
      };

      return Promise.all([
        saveMediaAndGetUrl(cover, 'cover', previous_pic_cover),
        saveMediaAndGetUrl(thumbnail, 'thumbnail', previous_pic_thumbnail)
      ]).then(([coverUrl, thumbnailUrl]) => {
        const pushableData = {
          title: title ? title : '',
          subtitle: subtitle ? subtitle : '',
          description: description ? description : '',
          pic_thumbnail: {
            src: thumbnailUrl ? thumbnailUrl.url : '',
            title: thumbnailUrl ? thumbnailUrl.title : ''
          },
          pic_cover: {
            src: coverUrl ? coverUrl.url : '',
            title: coverUrl ? coverUrl.title : ''
          },
          location: location ? location : '',
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
          state: state ? state : ''
        };

        const updateDB = async () => {
          return await firebase
            .database()
            .ref(`${resource}/${params.id}`)
            .update(pushableData)
            .then(() => {
              console.log('Data updated with success');
              return { data: params.data };
            })
            .catch(err => console.log('Cannot update ', err));
        };
        return updateDB();
      });
    } else {
      const { id, ...dataWithoutId } = params.data;
      return firebase
        .database()
        .ref(`${resource}/${params.id}`)
        .update(dataWithoutId)
        .then(_ => {
          console.log('Updated with Success');
          return { data: params.data };
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/UpdateService.js